export const gameConstants = {
  SET_DATA: 'SET_GAME_DATA',
  ADD_PLAYERS: 'ADD_PLAYERS',
  SET_ROUND: 'SET_ROUND',
  UPSERT_GROUP_ITEM: 'UPSERT_GROUP_ITEM',
};
